<div class="container-tig-item">
    <div class="help-c-title">
        <h4>安装指南</h4>
    </div>
    <div>
        <h4> Windows 字体安装</h4>
        <br>
        <p>Windows 10 为例：</p>
        <p> 双击字体文件（*.ttf），打开字体查看器</p>
        <br>
        <p>点击“安装”，安装字体:</p>
        <br>
        <div class="az-img">
            <img src="/assets/images/syff/install-01.png" alt="Onon字体 - 图片">
        </div>
        <br>
        <p> 或，右击字体文件</p>
        <p>点击“安装”，安装字体᠄</p>
        <br>
        <div class="az-img">
            <img src="/assets/images/syff/install-02.png" alt="Onon字体 - 图片">
        </div>
        <br>
        <br>
    </div>
</div>